import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M13.3282 5.33203H6.66391C5.9278 5.33203 5.33105 5.92877 5.33105 6.66489V13.3292C5.33105 14.0653 5.9278 14.6621 6.66391 14.6621H13.3282C14.0643 14.6621 14.6611 14.0653 14.6611 13.3292V6.66489C14.6611 5.92877 14.0643 5.33203 13.3282 5.33203Z"
      stroke="#919191"
      strokeWidth={1.33286}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M2.66587 10.6621C1.93279 10.6621 1.33301 10.0623 1.33301 9.32919V2.66489C1.33301 1.93182 1.93279 1.33203 2.66587 1.33203H9.33017C10.0632 1.33203 10.663 1.93182 10.663 2.66489"
      stroke="#919191"
      strokeWidth={1.33286}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default SVGComponent;
